module.exports = __webpack_public_path__ + "assets/img/commission1@2x.f857f79c.png";